import React from 'react'

const CovidTestingProcess = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 pt-md-5 py-4'>
            <div className='pb-3'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh- pb-'>
                    COVID-19 TESTING PROCESS WITH US
                </div>
                <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'px', marginBottom:'4px'}}/>
            </div>

            <div className='pb-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Are you going to be traveling by air? Have you recently returned from a trip and need to be tested? Or are you just concerned that you might have contracted it? Follow the simple steps on our website to complete your Covid-19 testing appointment form to get tested and receive your results in a short amount of time. Just show up at the testing location at the time slot you have chosen in the form. After collecting the specimen, the stress-free pre-travel Covid-19 test results will be sent directly to you via email or SMS.
                </div>
            </div>
        </div>
    </div>
  )
}

export default CovidTestingProcess